<template>
  <div class="container">
    <Title></Title>
    <div class="box">
      <advertisement />
      <interiorH :name="2" />
      <div class="list" v-for="(item, index) in mediatorList " :key="index">
        <!-- 头像 -->
        <img class="headimg" :src="baseURL + item.avatar" alt="">

        <!-- 姓名及介绍 -->
        <div class="">
          <div class="name">
            <span>{{ item.username }}</span>
            <!--  装饰线  -->
            <div class="RedThread"></div>
          </div>
          <!-- 个人介绍 -->
          <div class="desc">{{ item.description }}</div>

        </div>
      </div>


      <!-- 分页器 -->
      <van-pagination v-model="currentPage" @change='onChange' :total-items="total" :show-page-size="5">
      </van-pagination>
    </div>
    <copyright />
  </div>
</template>

<script>
import Title from '../components/title.vue'
import interiorH from '../components/interiorH.vue'
import copyright from "../components/copyright.vue";
import axios from 'axios';
export default {
  components: {
    Title,
    interiorH,
    copyright
  },
  data() {
    return {
      currentPage: 1,
      mediatorList: [{
        username: "张涛",
        avatar: "",
        description: '什么貌似没什么'
      }],
      total: 5

    }
  },
  mounted() {
    this.getmediatorList()
  },
  methods: {
    // 请求列表
    async getmediatorList(value) {
      let res = await axios.post("/api/mediator/page_list", { "current_page": value })
      this.mediatorList = res.data.data.records
      this.total = res.data.data.total
    },
    // 分页器触发事件
    onChange(value) {
      this.getmediatorList(value)
    }
  }
}
</script>

<style scoped>
.box {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 3rem 1rem 0 1rem;

}

p {
  width: 100%;
  height: 13.5rem;
  border-radius: 0.5rem;
  margin-top: 2.375rem;
  position: relative;
}

.tips {
  text-align: center;
  font-size: 0.8rem;
  color: #a6c1db;
  margin-bottom: 20px;
}

.list {
  display: flex;
  margin-bottom: 20px;
}

.headimg {
  width: 72px;
  height: 72px;
  border-radius: 50px;
  /* overflow: hidden; */
  margin-right: 13px;
}


.name {
  width: 66px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 13px;
}

.RedThread {
  width: 100%;
  height: 4px;
  background: #E04044;
}

.desc {
  height: 99px;
  overflow-y: auto;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
}


>>>.van-pagination__item--active {
  color: black;
  background-color: #fff;
}

>>>.van-pagination__item:active {
  color: #1989fa;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/page/list.vue